import React from "react";
import { Nullable } from "global";
import { Control, Path, FieldValues } from "react-hook-form";
import { ConditionsFieldsByRuleTypeRHF } from "../ConditionsFieldsByRuleType";

interface Props<FormValues extends FieldValues = FieldValues> {
  name: Path<FormValues>;
  control: Control<FormValues>;
  ruleType: Nullable<string> | undefined;
}

export const CriteriaBodyCell = <FormValues extends FieldValues = FieldValues>({
  ruleType,
  control,
  name,
}: Props<FormValues>) => {
  if (!ruleType) return null;

  return <ConditionsFieldsByRuleTypeRHF name={name} control={control} ruleType={ruleType} />;
};
